var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('DynamicList',{ref:"dynamicCardList",attrs:{"searchFormStructure":_vm.dataSearchFormStructure,"columns":_vm.dataColumns,"edit":_vm.dataEdit,"onRetrieve":_vm.onRetrieve,"root":"/report/commerce-sales20192020","searchArgs":_vm.searchArgs}},[_vm._t("default",[(_vm.dataCharts !== false)?_c('div',{staticClass:"card-group mb-3 animated fadeIn"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.dataCharts.count))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition("Nombre de participants")))])])]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.Core.Currency.format(_vm.dataCharts.subTotal)))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition("Sous-Total")))])])]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.Core.Currency.format(_vm.dataCharts.deduction)))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition("Déduction")))])])]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.Core.Currency.format(_vm.dataCharts.total)))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition("Total")))])])])]):_vm._e(),(_vm.dataCharts !== false && !_vm.Core.Session.AuthUser.can('league_manager'))?_c('div',{staticClass:"card-group mb-3 animated fadeIn"},_vm._l((_vm.dataCharts.leagues),function(league){return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.Core.Currency.format(league.total)))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v(_vm._s(league.label))])])])}),0):_vm._e(),(_vm.dataCharts !== false)?_c('div',{staticClass:"card-group mb-3 animated fadeIn"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition("Saisons")))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"}),_c('ChartPie',{attrs:{"labels":_vm.dataCharts.pie.season.labels,"sets":[
                                      {
                                         label: _vm.Core.Definition.getDefinition('Saisons'),
                                         backgroundColor: _vm.dataCharts.pie.season.backgroundColors,
                                         data: _vm.dataCharts.pie.season.datas
                                     }]}})],1)]),(!_vm.Core.Session.AuthUser.can('league_manager'))?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition("Ligues")))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"}),_c('ChartPie',{attrs:{"labels":_vm.dataCharts.pie.league.labels,"sets":[
                                    {
                                        label: _vm.Core.Definition.getDefinition('Ligues'),
                                        backgroundColor: _vm.dataCharts.pie.league.backgroundColors,
                                        data: _vm.dataCharts.pie.league.datas
                                    }]}})],1)]):_vm._e(),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition("Catégories")))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"}),_c('ChartPie',{attrs:{"labels":_vm.dataCharts.pie.category.labels,"sets":[
                                    {
                                        label: _vm.Core.Definition.getDefinition('Catégories'),
                                        backgroundColor: _vm.dataCharts.pie.category.backgroundColors,
                                        data: _vm.dataCharts.pie.category.datas
                                    }]}})],1)])]):_vm._e()],{"slot":"afterList"}),_vm._t("default",[_c('b-button',{staticClass:"mb-3",attrs:{"variant":"light"},on:{"click":function($event){_vm.$refs.modalExport.open = true}}},[_vm._v("\n                "+_vm._s(_vm.Core.Definition.getDefinition("Exporter sous format ..."))+"\n            ")]),_c('ModalExport',{ref:"modalExport",attrs:{"root":"/report/commerce-sales20192020","formStructure":{
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'exportFormat'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                 {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'exportTitle'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'firstname'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'lastname'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'eventProductTitle'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'ticketNumber'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                 {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'teamTitle'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'participantCategoryTitle'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'tShirtSize'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'tShirtCustomName'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'leagueTitle'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'regularPrice'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'promocode'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'email'
                                                }
                                            ]
                                        }
                                    ]
                                } ],
                            fields: [
                                {
                                    id: 'exportFormat',
                                    type: 'select',
                                    options: _vm.Core.Export.formatOptions(),
                                    label: _vm.Core.Definition.getDefinition('Format'),
                                    value: null,
                                    onSelect: function() {}
                                },
                                {
                                    id: 'exportTitle',
                                    type: 'text',
                                    label: _vm.Core.Definition.getDefinition('Titre'),
                                    value: '',
                                    required: true
                                },
                                {
                                    id: 'eventProductTitle',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Produit'),
                                    value: true,
                                    export: 'eventProductTitle',
                                    onChange: function() {}
                                },
                                {
                                    id: 'firstname',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Prénom'),
                                    value: true,
                                     export: 'firstname',
                                    onChange: function() {}
                                },
                                {
                                    id: 'lastname',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Nom de famille'),
                                    value: true,
                                     export: 'lastname',
                                    onChange: function() {}
                                },
                                {
                                    id: 'ticketNumber',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Numéro de billet'),
                                    value: true,
                                     export: 'ticketNumber',
                                    onChange: function() {}
                                },
                                {
                                    id: 'teamTitle',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Équipe'),
                                    value: true,
                                     export: 'teamTitle',
                                    onChange: function() {}
                                },
                                {
                                    id: 'participantCategoryTitle',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Catégorie'),
                                    value: true,
                                     export: 'participantCategoryTitle',
                                    onChange: function() {}
                                },
                                {
                                    id: 'tShirtSize',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Taille t-shirt'),
                                    value: true,
                                     export: 'tShirtSize',
                                    onChange: function() {}
                                },
                                {
                                    id: 'tShirtCustomName',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Nom personnalisé t-shirt'),
                                    value: true,
                                     export: 'tShirtCustomName',
                                    onChange: function() {}
                                },
                                {
                                    id: 'leagueTitle',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Ligue'),
                                    value: true,
                                     export: 'leagueTitle',
                                    onChange: function() {}
                                },
                                {
                                    id: 'regularPrice',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Prix régulier'),
                                    value: true,
                                     export: 'regularPrice',
                                    onChange: function() {}
                                },
                                {
                                    id: 'promocode',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Code promo'),
                                    value: true,
                                     export: 'promocode',
                                    onChange: function() {}
                                },
                                {
                                    id: 'email',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Courriel'),
                                    value: true,
                                     export: 'email',
                                    onChange: function() {}
                                } ]}},on:{"onSubmit":_vm.onExport}})],{"slot":"afterSearchForm"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }